import { DOCUMENT } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-legal-redirect',
  standalone: true,
  template: `
    <main class="route-bridge">
      <div class="route-bridge__label">Opening legal document...</div>
      <h1>Redirecting to the legal page</h1>
      <p>The selected legal document is loading.</p>
    </main>
  `
})
export class LegalRedirectComponent implements OnInit {
  private readonly document = inject(DOCUMENT);
  private readonly route = inject(ActivatedRoute);

  ngOnInit(): void {
    const docKey = String(this.route.snapshot.data['legalDoc'] || 'privacy').trim() || 'privacy';
    const targetUrl = new URL('/gfcore/index.html', this.document.location.origin);

    targetUrl.searchParams.set('page', 'legal');
    targetUrl.searchParams.set('doc', docKey);
    targetUrl.hash = this.document.location.hash;

    this.document.location.replace(targetUrl.toString());
  }
}
